import { render, staticRenderFns } from "./ProjectMessageLogger.vue?vue&type=template&id=0d0a624e&scoped=true&"
import script from "./ProjectMessageLogger.vue?vue&type=script&lang=js&"
export * from "./ProjectMessageLogger.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMessageLogger.vue?vue&type=style&index=0&id=0d0a624e&scoped=true&lang=css&"
import style1 from "./ProjectMessageLogger.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a624e",
  null
  
)

export default component.exports